import { useTranslation } from "react-i18next";

import Button from "src/components-v2/Button";
import Modal from "src/components-v2/Modal";

export type TermsConditionsModalProps = {
  /**
   * Show or hide modal
   */
  showTerms: boolean;

  /**
   * Modal toggle
   */
  toggleTerms: Function;
};

function TermsConditionsModal(props: TermsConditionsModalProps) {
  const { showTerms, toggleTerms } = props;
  const { t } = useTranslation("transaction");

  return (
    <Modal
      data-qaid="qa-modal-terms-and-conditions"
      title={t("summary.modal.terms-condition.title")}
      show={showTerms}
      onClose={() => toggleTerms(false)}
      closeOnOverlay
      withoutCloseButton
    >
      <ol className="u-pl-3">
        <li>
          {t("summary.modal.terms-condition.point-1-1")}
          <b>{t("summary.modal.terms-condition.point-1-bold-1")}</b>
          {t("summary.modal.terms-condition.point-1-2")}
          <b>{t("summary.modal.terms-condition.point-1-bold-2")}</b>
        </li>
        <li>{t("summary.modal.terms-condition.point-2")}</li>
        <li>{t("summary.modal.terms-condition.point-3")}</li>
        <li>
          <b>{t("summary.modal.terms-condition.point-4-bold-1")}</b>
          {t("summary.modal.terms-condition.point-4-1")}
        </li>
        <li>
          {t("summary.modal.terms-condition.point-5-1")}
          <b>{t("summary.modal.terms-condition.point-5-bold-1")}</b>
          {t("summary.modal.terms-condition.point-5-2")}
        </li>
        <li>
          {t("summary.modal.terms-condition.point-6-1")}
          <b>{t("summary.modal.terms-condition.point-6-bold-1")}</b>
          {t("summary.modal.terms-condition.point-6-2")}
          <b>{t("summary.modal.terms-condition.point-6-bold-2")}</b>
        </li>
        <li>
          {t("summary.modal.terms-condition.point-7-1")}
          <b>{t("summary.modal.terms-condition.point-7-bold-1")}</b>
          {t("summary.modal.terms-condition.point-7-2")}
          <b>{t("summary.modal.terms-condition.point-7-bold-2")}</b>
          {t("summary.modal.terms-condition.point-7-3")}
        </li>
        <li>{t("summary.modal.terms-condition.point-8")}</li>
        <li>
          {t("summary.modal.terms-condition.point-9-1")}
          <b>{t("summary.modal.terms-condition.point-9-bold-1")}</b>
          {t("summary.modal.terms-condition.point-9-2")}
        </li>
        <li>{t("summary.modal.terms-condition.point-10")}</li>
        <li>
          {t("summary.modal.terms-condition.point-11-1")}
          <b>{t("summary.modal.terms-condition.point-11-bold-1")}</b>
          {t("summary.modal.terms-condition.point-11-2")}
          <b>{t("summary.modal.terms-condition.point-11-bold-2")}</b>
          {t("summary.modal.terms-condition.point-11-3")}
        </li>
        <li>
          {t("summary.modal.terms-condition.point-12-1")}
          <b>{t("summary.modal.terms-condition.point-12-bold-1")}</b>
          {t("summary.modal.terms-condition.point-12-2")}
        </li>
      </ol>
      <div className="u-text-center">
        <p>
          {t("summary.modal.terms-condition.desc-1")}
          <b>{t("summary.modal.terms-condition.desc-bold-1")}</b>
          {t("summary.modal.terms-condition.desc-2")}
          <b>{t("summary.modal.terms-condition.desc-bold-2")}</b>
          {t("summary.modal.terms-condition.desc-3")}
        </p>
      </div>

      <Button variant="secondary" onClick={() => toggleTerms(false)} block>
        {t("summary.modal.terms-condition.agree")}
      </Button>
    </Modal>
  );
}

export default TermsConditionsModal;
